import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import shareGroupService from "../../services/shareGroupService";

const useShareGroups = ({
    accountExternalId,
    siteExternalIds,
}: {
    accountExternalId: string;
    siteExternalIds: string[];
}) =>
    useQuery(
        [queryKeys.shareGroups, accountExternalId, siteExternalIds?.join(",")],
        () => shareGroupService.fetchShareGroups(siteExternalIds),
        { enabled: !!accountExternalId }
    );

export default useShareGroups;
